var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileHomeInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87996 12.1462V22.2598H11.4776H19.0752V12.1462L11.4344 4.89758L3.87996 12.1462Z",
    stroke: "#404554",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4344 4.89759L3.27053 12.7795C2.74606 13.2859 1.91041 13.2712 1.40406 12.7467C0.897701 12.2223 0.912385 11.3866 1.43685 10.8803L11.4117 1.24991L21.6264 10.8689C22.1572 11.3687 22.1823 12.2041 21.6825 12.7348C21.1827 13.2656 20.3473 13.2907 19.8165 12.7909L11.4344 4.89759Z",
    stroke: "#404554",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92001 22L8.92001 17.5135C8.92001 16.1248 10.0457 14.9991 11.4344 14.9991V14.9991C12.8231 14.9991 13.9488 16.1248 13.9488 17.5135V22",
    stroke: "#404554",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5256 12.4557H10.2438",
    stroke: "#404554",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileHomeInactive);
export default __webpack_public_path__ + "static/media/MobileHomeInactive.843e8f6c.svg";
export { ForwardRef as ReactComponent };